import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslocoService, getBrowserLang } from '@ngneat/transloco';
import { ClientBrowserSessionStorageService } from './client-browser-session-storage.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';
import { Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageUtilService {

  lang?: string

  languages = environment.availableLangs

  constructor(
    private translocoService: TranslocoService,
    private sessionStorageService: ClientBrowserSessionStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Idioma por defecto en prerender
    this.lang = environment.dfConfigLang;
    // Solo si estamos en navegador, leer de sessionStorage o navegador
    if (isPlatformBrowser(this.platformId)) {
      const storedLang = this.sessionStorageService.getItem('lang')?.toString();

      if (storedLang) {
        this.lang = storedLang;
      } else {
        const browserLang = getBrowserLang();
        if (browserLang && this.languages.includes(browserLang)) {
          this.lang = browserLang;
        }
      }
    }

    this.translocoService.setDefaultLang(this.lang);
    this.translocoService.setActiveLang(this.lang);
  }

  translate(arg: string) {
    return this.translocoService.translate(arg)
  }

  fetchTranslation(arg: string): Observable<string> {
    return this.translocoService.selectTranslate(arg).pipe(take(1));
  }


  getLangActive() {
    return this.translocoService.getActiveLang()
  }

  getValidLanguages() {
    return this.languages
  }

  setLanguage(arg: string) {
    if (arg) {
      const vLang = this.languages.find(lang => lang === arg.toLocaleLowerCase())
      if (vLang != undefined && vLang != null) {
        this.sessionStorageService.setItem('lang', vLang)
        this.translocoService.setDefaultLang(vLang)
        this.translocoService.setActiveLang(vLang)
      }
    }
  }
}
